import React, { Component } from 'react';
import Script from '../../../components/head/script';

// eslint-disable-next-line react/prefer-stateless-function
class Dwen extends Component {
  postUp() {
    return (
      <Script
        type="text/javascript"
        innerHtml={
          "(function () {window.setTimeout(function() {var e = document.createElement('script'); e.type = 'text/javascript'; e.async = true; e.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'www.lightboxcdn.com/vendor/252af0a6-c9ae-4612-9dbe-5d1552fad623/lightbox_inline.js?mb=' + (new Date().getTime()); var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(e, s);}, 500);})();"
        }
      />
    );
  }
  render() {
    return <div className="dwen-container"> 
     <section className="dwen-page">{this.postUp()} 
     </section> 
    <iframe class="dwen_iframe" src="//inc2.inc.com/hosted_html/dwen_fc.html"/> 
    <div class="inline-form" id='lightbox-inline-form-1a925821-c69e-4391-ae64-41445ff5d3ae'/>
    </div>;
  }
}

export default Dwen;
